import api from "./axios";

export async function fetchJsonFromS3Url(s3Key) {
    if (!s3Key) {
        console.error("fetchJsonFromS3Url was called with an empty key.");
        throw new Error("S3 key is required to fetch the file.");
    }
    try {
        const response = await api.get(`/s3/json/${encodeURIComponent(s3Key)}`);
        if (response.status !== 200 || !response.data) {
            throw new Error('הקובץ לא נמצא או פג תוקף הקישור');
        }
        return response.data;
    } catch (e) {
        console.error("Failed to fetch JSON:", e);
        if (e instanceof SyntaxError) {
            throw new Error('הקובץ שהתקבל אינו בפורמט JSON תקין.');
        }
        throw new Error('שגיאה בקבלת הקובץ. נסה שוב מאוחר יותר.');
    }
}

export async function getSignedUrlForS3(s3Key) {
    if (!s3Key) {
        console.error("getSignedUrlForS3 was called with an empty s3Key.");
        throw new Error("An S3 key is required to get a signed URL.");
    }
    try {
        const response = await api.get(`/s3/signed-url/${encodeURIComponent(s3Key)}`);
        if (response.status !== 200 || !response.data.url) {
            throw new Error('Failed to get signed URL');
        }
        return response.data.url;
    } catch (err) {
        console.error('Error fetching signed URL:', err);
        throw new Error("Could not get the file URL. Please try again.");
    }
}




// export async function fetchJsonFromS3Url(url) {
//     const res = await axios.get(url);
//     if (res.status !== 200) throw new Error('הקובץ לא נמצא או פג תוקף הקישור');
//     const text = typeof res.data === 'string' ? res.data : JSON.stringify(res.data);
//     try {
//         return JSON.parse(text);
//     } catch (e) {
//         throw new Error('הקובץ לא בפורמט תקין');
//     }
// }

